export default "__VITE_ASSET__FTmKDne9__"